/**
 * Side-effect imports for ngx-markdown runtime extras.
 * Imported from main.ts before bootstrapApplication.
 */
import Prism from 'prismjs';

import 'prismjs/components/prism-markup.js';
import 'prismjs/components/prism-clike.js';
import 'prismjs/components/prism-javascript.js';
import 'prismjs/components/prism-typescript.js';
import 'prismjs/components/prism-json.js';
import 'prismjs/components/prism-bash.js';
import 'prismjs/components/prism-python.js';
import 'prismjs/components/prism-css.js';
import 'prismjs/components/prism-http.js';
import 'prismjs/components/prism-yaml.js';
import 'prismjs/components/prism-nginx.js';

void Prism;
